/**
 * 포인트 안내 컴포넌트
 */
import type { PointsTranslations } from './types';

interface PointsGuideProps {
  translations: PointsTranslations;
}

export function PointsGuide({ translations: t }: PointsGuideProps) {
  return (
    <div className="bg-background rounded-[10px] p-[16px] shadow-sm">
      <div className="flex items-center gap-[10px] mb-[16px]">
        <div className="flex items-center justify-center w-[32px] h-[32px] bg-primary/10 rounded-[8px] shrink-0">
          <span className="text-[18px]">💡</span>
        </div>
        <h3 className="text-[15px] font-bold text-foreground">
          {t.pointsGuideTitle}
        </h3>
      </div>

      <div className="space-y-[12px]">
        <div className="flex items-start gap-[12px] rounded-[8px] bg-background px-[12px] py-[0px]">
          <div className="flex items-center justify-center w-[6px] h-[6px] bg-primary rounded-full shrink-0 mt-[6px]" />
          <p className="text-[13px] text-foreground flex-1">
            {t.pointsGuide1}
          </p>
        </div>
        <div className="flex items-start gap-[12px] rounded-[8px] bg-background px-[12px] py-[0px] m-[0px]">
          <div className="flex items-center justify-center w-[6px] h-[6px] bg-primary rounded-full shrink-0 mt-[6px]" />
          <p className="text-[13px] text-foreground flex-1">
            {t.pointsGuide2}
          </p>
        </div>
        <div className="flex items-start gap-[12px] p-[12px] rounded-[8px] bg-background">
          <div className="flex items-center justify-center w-[6px] h-[6px] bg-primary rounded-full shrink-0 mt-[6px]" />
          <p className="text-[13px] text-foreground flex-1">
            {t.pointsGuide3}
          </p>
        </div>
      </div>
    </div>
  );
}
